module.exports = function flattenNodesConfig(nodesConfig) {
	const flat = nodesConfig.map((nodeConfig) => {
		let flat = { ...nodeConfig };
		if (nodeConfig.options) {
			flat = {
				...flat,
				...nodeConfig.options,
			};
			if (nodeConfig.options.list) {
				flat = {
					...flat,
					...nodeConfig.options.list,
				};
			}
			if (nodeConfig.options.single) {
				flat = {
					...flat,
					...nodeConfig.options.single,
				};
			}
		}
		return flat;
	});
	// console.warn(
	// 	"flattening nodesConfig for legacy compatibility",
	// 	nodesConfig,
	// 	"->",
	// 	flat
	// );
	return flat;
};
